import { ColumnType } from '@dynamika-shared/ui/Table/Table.types';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Button } from '@dynamika-shared/ui/Button/Button';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';
import { TruncatedText } from '@dynamika-shared/ui/TruncatedText/TruncatedText';
import { routesPath } from '@router/routes';
import { prepareUrl } from '@utils/routerHelpers';
import { SiteSubjectType } from '@restore/ValidationSpecialistSubjects/ValidationSpecialistSubjects.types';

const loading = () => (
  <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300' />
);

export const SubjectListColumns = (
  clinicalTrialId: string
): ColumnType<SiteSubjectType>[] => {
  return [
  {
    name: 'siteCode',
    thClassName: 'w-[15%] min-w-[15%] max-w-[15%]',
    header() {
      return 'Site';
    },
    getValue(row) {
      return row.siteCode ?? '-';
    },
    loading,
    hasSorting: true,
  },
  {
    name: 'patientCode',
    thClassName: 'w-[15%] min-w-[15%] max-w-[15%]',
    header() {
      return 'Subject';
    },
      getValue(row) {
        return <TruncatedText text={row.patientCode || row.code} truncate tooltip />;
      },
    loading,
    hasSorting: true,
  },
  {
    name: 'visitName',
    thClassName: 'w-[15%] min-w-[15%] max-w-[15%]',
    header() {
      return <p className='flex items-center'>Last Uploaded Visit</p>;
    },
    getValue(row) {
      const lastVisit = row.lastVisit;
      const isUnscheduled =
        lastVisit?.type === 'UNSCHEDULED' && !lastVisit?.earlyTermination;
      const visitName = isUnscheduled ? (
        <div>
          <div>Unscheduled</div>
          <div>
            {format(
              new Date((lastVisit?.latestUpload || lastVisit?.name) ?? '-'),
              'dd-MMM-yyy'
            )}
          </div>
        </div>
      ) : (
        row.lastUploadedVisitName || lastVisit?.name || '-'
      );
      return <div className=''>{visitName}</div>;
    },
    loading,
    hasSorting: true,
  },
  {
    name: 'latestUpload',
    thClassName: 'w-[20%] min-w-[20%] max-w-[20%]',
    header() {
      return 'Latest Upload Date';
    },
    getValue(row) {
      const lastVisit = row.lastVisit;
      const uploadDate = lastVisit?.latestUpload || row.lastUploadedDate;

      if (!uploadDate) {
        return <div className=''>-</div>;
      }

      try {
        const date = new Date(uploadDate);
        return <div className=''>{format(date, 'dd-MMM-yyyy')}</div>;
      } catch (error) {
        console.error('Error formatting date:', uploadDate, error);
        return <div className=''>-</div>;
      }
    },
    loading,
    hasSorting: true,
  },
  {
    name: 'action',
    thClassName: 'w-[5%] min-w-[5%] max-w-[5%]',
    header() {
      return 'Action';
    },
    getValue(row) {
      return (
        <Link to={prepareUrl(routesPath.validationSpecialistSubjectDetailClinicalTrial, [clinicalTrialId, row.id])}>
          <Button
            type='text'
            onClick={() => null}
            className='flex h-4 !min-h-fit w-4 cursor-pointer items-center justify-center !p-0'
          >
            <ChevronIcon dir='right' className='h-2 w-2 text-pastelBlue' />
          </Button>
        </Link>
      );
    },
    loading,
  },
];
};
